<!-- Builder Start -->
<div id="{{position}}" class="heroBackImageContainer" *ngIf="!loading">
  <div class="vd-container" [attr.data-aos]="allElementAnimation ? allElementAnimation : null">
    <div class="bg_wrap">
      <video *ngIf='video'  oncanplay="this.play()" onloadedmetadata="this.muted = true" autoplay loop id="myVideo">
        <source [src]="video" type="video/mp4" />
      </video>
      <div class="content" *ngIf="title || text || buttonText">
        <div class="global-max-width global-max-width-hero-background">
          <h1 [attr.data-aos]="textAnimation ? textAnimation : null" 
          [style.textAlign]="textAlign" class="mat-h1"
          [innerHtml]="title | safeHtml"
          ></h1>
          <p [attr.data-aos]="textAnimation ? textAnimation : null" [style.textAlign]="textAlign" [innerHtml]="text | safeHtml"></p>
          <div [attr.data-aos]="buttonAnimation ? buttonAnimation : null" *ngIf="buttonText"
            [style.textAlign]="textAlign">
            <a *ngIf="buttonLinkType == 'Scroll to other component'" class="app-button mat-raised-button"
              mat-raised-button="" rel="noopener" tabindex="0" aria-disabled="false" [href]="buttonLink | safeUrl"
              [target]="''">
              <span class="mat-button-wrapper"> {{ buttonText }} </span>
            </a>
            <a *ngIf="buttonLinkType != 'Scroll to other component'" class="app-button mat-raised-button"
              mat-raised-button="" [href]="buttonLink" target="_blank" rel="noopener" tabindex="0" aria-disabled="false"
              style="cursor: pointer" (click)="clickExternalLink(buttonLink)">
              <span class="mat-button-wrapper"> {{ buttonText }} </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>